import { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import MDInput from "../MDInput";
import MDBox from "../MDBox";
import MDAutocomplete from "../MDAutocomplete";

import { countryTuples } from 'country-region-data';

const countries = countryTuples.map(t => {
  return { value: t[1], label: t[0] }
})

function CountrySelect({ label, name, onChange, value, ...rest }) {
  const [dataValue, setDataValue] = useState(null)
  useEffect(() => {
    let defaultValue = null
    if (value) {
      defaultValue = countries.find(c => c.value === value) || null
    }
    setDataValue(defaultValue)
  }, [value])

  const handleChange = (e, result) => {
    setDataValue(result)
    if (typeof onChange !== 'undefined') {
      onChange({
        target: {
          name,
          value: result?.value
        }
      })
    }
  }

  return (
    <MDAutocomplete
      options={countries}
      autoHighlight
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => (
        <MDBox component="li" {...props}>
          {option.label}
        </MDBox>
      )}
      value={dataValue}
      onChange={handleChange}
      isOptionEqualToValue={(option, selected) => {
        return option.value === selected.value
      }}
      renderInput={(params) => (
        <MDInput
          {...params}
          label={label}
          name={name}
          inputProps={{
            ...params.inputProps,
          }}
        />
      )}
      {...rest}
    />
  );
}

CountrySelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default CountrySelect